"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Close = _interopRequireDefault(require("@quintoandar/cozy-icons/Close"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _DialogContent = _interopRequireDefault(require("../../DialogContent"));
var _DialogIcon = _interopRequireDefault(require("../../DialogIcon"));
var _DialogIllustration = _interopRequireDefault(require("../../DialogIllustration"));
var _DialogTitle = _interopRequireDefault(require("../../DialogTitle"));
var _Dialog = _interopRequireDefault(require("../Dialog"));
var Styles = _interopRequireWildcard(require("./WindowDialog.styles"));
var _classnames = _interopRequireDefault(require("./classnames"));
var _messages = _interopRequireDefault(require("./messages"));
var _excluded = ["children", "icon", "illustrationSrc", "open", "onClose", "title", "intl", "alt"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var WindowDialog = function WindowDialog(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    illustrationSrc = _ref.illustrationSrc,
    open = _ref.open,
    onClose = _ref.onClose,
    title = _ref.title,
    intl = _ref.intl,
    alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  var hasTitle = Boolean(title);
  var _useState = (0, _react.useState)(function () {
      return open;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var initialRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    setIsOpen(open);
  }, [open]);
  (0, _react.useEffect)(function () {
    if (initialRender.current) {
      initialRender.current = false;
    } else if (onClose && !isOpen) {
      onClose(false);
    }
  }, [isOpen]);
  var handleOnClose = function handleOnClose() {
    setIsOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    className: _classnames["default"].WINDOW_DIALOG,
    open: isOpen,
    onClose: handleOnClose
  }, props), /*#__PURE__*/_react["default"].createElement(Styles.WindowDialogHeader, {
    className: _classnames["default"].WINDOW_DIALOG_HEADER,
    hasTitle: hasTitle
  }, title && /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    className: _classnames["default"].WINDOW_DIALOG_TITLE,
    paddingTop: "0",
    paddingBottom: "0"
  }, title), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: _classnames["default"].WINDOW_DIALOG_HEADER_CLOSE,
    variant: "default",
    onClick: handleOnClose,
    "aria-label": intl.formatMessage(_messages["default"].closeButtonAriaLabel),
    icon: _Close["default"]
  })), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
    className: _classnames["default"].WINDOW_DIALOG_CONTENT,
    dividers: hasTitle,
    paddingTop: "0"
  }, illustrationSrc && /*#__PURE__*/_react["default"].createElement(_DialogIllustration["default"], {
    src: illustrationSrc,
    alt: alt
  }), icon && /*#__PURE__*/_react["default"].createElement(Styles.IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_DialogIcon["default"], {
    icon: icon,
    fontSize: "40px"
  })), children));
};
WindowDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  icon: _propTypes["default"].elementType,
  illustrationSrc: _propTypes["default"].string,
  maxWidth: _propTypes["default"].oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
  fullScreen: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  title: _propTypes["default"].string,
  intl: _propTypes["default"].object.isRequired,
  alt: _propTypes["default"].string
} : {};
WindowDialog.defaultProps = {
  maxWidth: 'xs',
  fullScreen: false,
  open: false,
  alt: ''
};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(WindowDialog);